// @flow

import { all, put, takeEvery, call } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import actionCreators from "@modules/service/actionCreator";
import {
  GetManagerSelfServiceSettings,
  UpdateManagerSelfServiceSettings,
} from "@modules/service/constants/actions";
import type { ManagerSelfServiceSettings } from "@modules/service/reducer/manager-self-service/types";

// READ

type ManagerSelfServiceRequest = $Exact<{
  clientId: string,
}>;

export function* onGetManagerSelfServiceSettings({
  payload,
}: Action<ManagerSelfServiceRequest>): Generator<*, void, *> {
  try {
    if (!payload || !payload.clientId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.get,
      `/api/v2/service-admin/client/${payload.clientId}/service-config/platform/manager-self-service`,
    );

    yield put(actionCreators.GetManagerSelfServiceSettingsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetManagerSelfServiceSettingsError(e.response));
  }
}

// UPDATE

type UpdateManagerSelfServiceRequest = $Exact<{
  clientId: string,
  data: ManagerSelfServiceSettings,
}>;

export function* onUpdateManagerSelfServiceSettings({
  payload,
}: Action<UpdateManagerSelfServiceRequest>): Generator<*, void, *> {
  try {
    if (!payload || !payload.clientId || !payload.data) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.put,
      `/api/v2/service-admin/client/${payload.clientId}/service-config/platform/manager-self-service`,
      payload.data,
    );

    yield put(actionCreators.UpdateManagerSelfServiceSettingsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.UpdateManagerSelfServiceSettingsError(e.response));
  }
}

// ROOT
export function* ManagerSelfServiceSaga(): Generator<*, void, void> {
  yield all([takeEvery(GetManagerSelfServiceSettings, onGetManagerSelfServiceSettings)]);
  yield all([takeEvery(UpdateManagerSelfServiceSettings, onUpdateManagerSelfServiceSettings)]);
}

export default ManagerSelfServiceSaga;
